import * as types from "./types";

export const setLoading = (loading) => {
  return {
    type: types.SET_LOADING,
    payload: loading,
  };
};

export const setSudoLoading = (loading) => {
  return {
    type: types.SET_SUDO_LOADING,
    payload: loading,
  };
};
